{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "file:///BasicInfo.json",
  "title": "BasicInfo",
  "type": "object",
  "properties": {
    "preferredName": {
      "type": "string",
      "minLength": 1
    },
    "preferredPronouns": {
      "type": "string",
      "minLength": 1
    },
    "graduationYear": {
      "type": "number",
      "minimum": 2022,
      "maximum": 2040
    },
    "graduationSemester": {
      "type": "string",
      "minLength": 1
    },
    "isUndergraduate": {
      "type": "string",
      "minLength": 1
    }
  }
}